"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../Schema/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ImageCropdataField extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getField", () => {
      const _this$props = this.props,
            uiSchema = _this$props.uiSchema,
            defaultOptions = _this$props.defaultOptions;
      const uiOptions = (0, _utils.getUiOptions)(uiSchema);
      return _extends({}, this.props, {
        uiSchema: _extends({}, uiSchema, {
          "ui:options": _extends({}, defaultOptions, {}, uiOptions)
        })
      });
    });
  }

  render() {
    const _this$getField = this.getField(),
          registry = _this$getField.registry,
          uiSchema = _this$getField.uiSchema;

    const ObjectField = registry.fields.ObjectField;
    return _react.default.createElement(ObjectField, _extends({}, this.props, {
      uiSchema: uiSchema
    }));
  }

}

_defineProperty(ImageCropdataField, "defaultProps", {
  defaultOptions: {
    "layout": "imageCropper"
  }
});

var _default = ImageCropdataField;
exports.default = _default;
module.exports = exports.default;